import type {ReactElement} from 'react';
import React from 'react';
import {BrandAssetName} from '@Components/editor-brands/editor-brands.types';
import EditorBrands from '@Components/editor-brands';
import BrandColors from '@Components/editor-brands/components/brand-colors';
import {noop} from '@Utils/general.util';
import type {BrandsSectionProperties} from '@Components/editor-brands/editor-brands';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba} from '@Utils/color.util';
import {trackHalloweenBrandKitUsageIfApplicable} from '@Libraries/brands-library';

interface BrandsSectionProps extends BrandsSectionProperties {
  className?: string;
  showSmallDropdownHeader?: boolean;

  onAddBrandAssetClicked(): void;

  onColorSelect(color: RGBA): void;
}

export function BrandsSection({
  removeDefaultPadding = false,
  dontOpenBrandsDropdown = false,
  onClickBrandsSelector = noop,
  showSmallDropdownHeader = false,
  ...props
}: BrandsSectionProps): ReactElement<any> | null {
  return (
    <EditorBrands
      className={props.className}
      isSmallSection
      brandAsset={BrandAssetName.COLORS}
      onAddBrandAsset={(): void => {
        props.onAddBrandAssetClicked();
      }}
      dontOpenBrandsDropdown={dontOpenBrandsDropdown}
      removeDefaultPadding={removeDefaultPadding}
      onClickBrandsSelector={(): void => {
        onClickBrandsSelector();
      }}
      showSmallDropdownHeader={showSmallDropdownHeader}
    >
      <BrandColors
        onAddColor={(color: string): void => {
          trackHalloweenBrandKitUsageIfApplicable();
          props.onColorSelect(hexToRgba(color));
        }}
      />
    </EditorBrands>
  );
}
